<div class="content" *ngIf="config">
  <div
    class="w-100 d-flex justify-content-center"
    [ngStyle]="{ 'background-color': config.why_ziraxi.background_color }"
  >
    <div
      class="wavy-box"
      [ngStyle]="{
        'background-color': '#f5f4f9',
        height: '22rem'
      }"
    ></div>
  </div>

  <div
    [ngStyle]="{
      'background-image':
        'url(../../../../../assets/image/' +
        config.why_ziraxi.background_src +
        '.svg)'
    }"
    class="background position-relative"
  >
    <div
      class="bg-white container main-content pb-5"
      [ngClass]="{
        'show-more': !showMoreClicked,
        'show-less': showMoreClicked
      }"
    >
      <div
        [innerHtml]="config.why_ziraxi.first_content"
        (click)="getRoute($event)"
        #firstElement
      ></div>
      <img
        class="content-image"
        [src]="
          '../../../../../assets/image/' +
          config.why_ziraxi.background_src +
          (config.why_ziraxi.background_postfix || '.png')
        "
        [alt]="config.why_ziraxi.background_alt"
      />
      <div
        [innerHtml]="config.why_ziraxi.secound_content"
        (click)="getRoute($event)"
      ></div>
      <ng-container *ngIf="config.why_ziraxi.line_content">
        <h2
          [ngClass]="{
            'd-flex justify-content-center': config.why_ziraxi.line_button
          }"
        >
          <span [ngClass]="{ absolute: config.why_ziraxi.line_button }">
            <button
              *ngIf="config.why_ziraxi.line_button"
              class="btn submit-btn"
              (click)="scrollPrintOrder()"
            >
              {{ config.why_ziraxi.button_text }}
            </button>
            {{ config.why_ziraxi.line_content }}
          </span>
        </h2>
        <div
          *ngIf="!config.why_ziraxi.line_button"
          class="w-100 d-flex justify-content-center my-5"
        >
          <button class="btn submit-btn" (click)="scrollPrintOrder()">
            {{ config.why_ziraxi.button_text }}
          </button>
        </div>
        <div
          [innerHTML]="config.why_ziraxi.third_content"
          (click)="getRoute($event)"
        ></div>
      </ng-container>
      <div #lastElement class="w-100 d-flex justify-content-center">
        <svg
          width="35"
          height="35"
          viewBox="0 0 58 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          (click)="ViewMore(firstElement)"
          class="cursor-pointer"
        >
          <path
            d="M52.9238 29.4619L28.9998 5.53791"
            stroke="#327DF0"
            stroke-width="10"
            stroke-linecap="round"
          />
          <path
            d="M5.076 29.4619L29 5.53791"
            stroke="#327DF0"
            stroke-width="10"
            stroke-linecap="round"
          />
        </svg>
      </div>
    </div>

    <div
      class="w-100 position-relative d-flex justify-content-center align-items-center"
    >
      <div
        *ngIf="showMoreClicked"
        class="w-100 d-flex justify-content-center video-bg-mobile"
        [ngStyle]="{ 'background-color': config.color }"
      >
        <div
          class="wavy-box"
          [ngStyle]="{
            'background-color': config.why_ziraxi.background_color,
            height: '17rem'
          }"
        ></div>
      </div>

      <ng-container *ngIf="!showMoreClicked">
        <div class="show-more-container"></div>
        <div
          class="w-100 d-flex justify-content-center video-bg-mobile"
          [ngStyle]="{ 'background-color': config.color }"
        >
          <div
            class="wavy-box"
            [ngStyle]="{
              'background-color': '#fff',
              height: '17rem'
            }"
          ></div>
          <svg
            (click)="showMoreClicked = !showMoreClicked"
            class="show-more-icon cursor-pointer mb-5"
            width="58"
            height="35"
            viewBox="0 0 58 35"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.07617 5.53809L29.0002 29.4621"
              stroke="#327DF0"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              d="M52.924 5.53809L29 29.4621"
              stroke="#327DF0"
              stroke-width="10"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- <app-landing-video [config]="config"></app-landing-video> -->
  <div class="position-relative video-bg d-md-block d-none">
    <!-- <img [src]="'../../../assets/image/' + config.why_ziraxi.background_src + '-video-bg.svg'" class="background2"/> -->

    <div [ngStyle]="{ 'background-color': config.color }" class="">
      <div class="video-background px-5">
        <div class="bg-white container position-relative d-flex flex-row">
          <div class="video-img"></div>

          <div
            #gallery
            class="col-sm-3 video-gallary p-3 position-relative mb-5"
          >
            <div
              class="text-center border-bottom pb-1 border-2 border-white mx-4 mb-2"
            >
              <h3 class="text fs-5 fw-bold text-white">ویدیوهای مرتبط</h3>
            </div>
            <div class="d-flex flex-column">
              <div class="video-thumnail my-2 p-1">
                <div
                  class="d-flex justify-content-center align-items-center position-relative"
                >
                  <button class="play-btn">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.498 11.6201L0.498047 23.1201V0.120117L21.498 11.6201Z"
                      />
                    </svg>
                  </button>
                  <img src="../../../../../assets/image/video-thumnail.png" />
                </div>
                <button class="video-button btn fs-5">
                  نحوه پرینت در زیراکسی
                </button>
              </div>
              <div class="video-thumnail my-2 p-1">
                <div
                  class="d-flex justify-content-center align-items-center position-relative"
                >
                  <button class="play-btn">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.498 11.6201L0.498047 23.1201V0.120117L21.498 11.6201Z"
                      />
                    </svg>
                  </button>
                  <img src="../../../../../assets/image/video-thumnail.png" />
                </div>
                <button class="video-button btn fs-5">
                  نحوه پرینت در زیراکسی
                </button>
              </div>
              <div class="video-thumnail my-2 p-1">
                <div
                  class="d-flex justify-content-center align-items-center position-relative"
                >
                  <button class="play-btn">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.498 11.6201L0.498047 23.1201V0.120117L21.498 11.6201Z"
                      />
                    </svg>
                  </button>
                  <img src="../../../../../assets/image/video-thumnail.png" />
                </div>
                <button class="video-button btn fs-5">
                  نحوه پرینت در زیراکسی
                </button>
              </div>
              <div class="video-thumnail my-2 p-1">
                <div
                  class="d-flex justify-content-center align-items-center position-relative"
                >
                  <button class="play-btn">
                    <svg
                      width="22"
                      height="24"
                      viewBox="0 0 22 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.498 11.6201L0.498047 23.1201V0.120117L21.498 11.6201Z"
                      />
                    </svg>
                  </button>
                  <img src="../../../../../assets/image/video-thumnail.png" />
                </div>
                <button class="video-button btn fs-5">
                  نحوه پرینت در زیراکسی
                </button>
              </div>
            </div>
          </div>
          <div class="col-sm-9 pe-5">
            <video width="100%" src=""></video>
            <div class="w-100 py-3 mb-5">
              <h5 class="mb-4">تیتر توضیحات ویدیو</h5>
              <p>
                توضیح ویدئو
              </p>
            </div>
          </div>

          <!-- <div class="w-100 position-absolute top-10"> -->

          <div
            (click)="onNextElement()"
            class="col-sm-3 position-absolute d-flex justify-content-center bottom-44"
          >
            <div class="arrow-container col-6">
              <img src="../../../../../assets/image/arrow.svg" />
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-center d-md-block d-none">
    <div
      class="wavy-box"
      [ngStyle]="{
        'background-color': config.color,
        height: '17rem'
      }"
    ></div>
  </div>
</div>
